module.exports = __webpack_public_path__ + "img/file-earmark-zip-fill.23ea05c8.svg";